import React from "react";
import * as yup from "yup";
import { keyFromIdentity } from "../helpers";
import { QuestionProps } from "../question";
import TextInput from "./text";

export const validator = (
  { identity, required }: QuestionProps,
  _questionsMap: Record<string, QuestionProps>,
  parent?: string,
  index?: number,
): Record<string, yup.AnySchema> => {
  const key = keyFromIdentity(identity, parent, index);
  const value = yup.number().nullable().positive("Must be more than zero");

  return {
    [key]: required ? value.required() : value,
  };
};

const CurrencyInput = (props : any) => <TextInput {...props} type="currency_usd" />;

CurrencyInput.validator = validator;
export default CurrencyInput;
